import React from 'react';
import { ASSETS } from '../../constants/assets';
import './Auth.scss';

interface AuthLayoutProps {
  children: React.ReactNode;
  tagline?: string;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children, tagline }) => {
  return (
    <div
      className="auth-root"
      style={{ backgroundImage: `url(${ASSETS.images.loginBackground})` }}
    >
      <div className="auth-overlay" aria-hidden="true" />

      <div className="auth-content">
        <header className="auth-brand">
          <img
            src="/assets/images/logo.svg"
            alt="Saathi4U.com"
            className="auth-logo"
          />
          {tagline && <p className="auth-tagline">{tagline}</p>}
        </header>

        {children}

        <footer className="auth-footer">
          © 2026 Pithad Solutions. All rights reserved.
        </footer>
      </div>
    </div>
  );
};
